import { render } from "./BacktestView.vue?vue&type=template&id=666e51f4"
import script from "./BacktestView.vue?vue&type=script&lang=js"
export * from "./BacktestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__